import React, { useEffect, useState } from 'react';
import { useParkingWizardStore } from 'Stores/ParkingWizardStore';
import { getParkingLocations, ParkingLocationDto } from 'Services/Api/_HumanWritten/ParkingService';

export function ParkingLocationStep() {
	const { location, setLocation, setStep, setError, setLoading, isLoading } = useParkingWizardStore();
	const [locations, setLocations] = useState<ParkingLocationDto[]>([]);

	useEffect(() => {
		setLoading(true);
		getParkingLocations()
			.then(data => {
				setLocations(data);
				setError(null);
			})
			.catch(() => {
				setError('Failed to load parking locations.');
			})
			.finally(() => {
				setLoading(false);
			});
	}, [setError, setLoading]);

	const handleSelect = (loc: ParkingLocationDto) => {
		setLocation(loc);
	};

	const handleContinue = () => {
		if (!location) {
			setError('Please select a parking location.');
			return;
		}
		setError(null);
		setStep('vehicles');
	};

	if (isLoading) {
		return <div className="parking-wizard__loading">Loading locations...</div>;
	}

	return (
		<div className="parking-wizard__step parking-location-step">
			<h2>Select a Parking Location</h2>
			<div className="parking-location-step__list">
				{locations.map(loc => (
					<div
						key={loc.id}
						className={`parking-location-step__card ${location?.id === loc.id ? 'selected' : ''}`}
						onClick={() => handleSelect(loc)}
						role="button"
						tabIndex={0}
						onKeyDown={e => {
							if (e.key === 'Enter' || e.key === ' ') handleSelect(loc);
						}}
					>
						<h3>{loc.name}</h3>
						{loc.address && <p>{loc.address}</p>}
					</div>
				))}
				{locations.length === 0 && <p>No parking locations are currently available.</p>}
			</div>
			<div className="parking-wizard__actions">
				<button type="button" className="btn btn-primary" onClick={handleContinue} disabled={!location}>
					Continue
				</button>
			</div>
		</div>
	);
}
